<template>
	<nut-dialog
		teleport="body"
		title="编辑"
		okText="保存"
		:visible="modelValue"
		@ok="handleSave"
		@cancel="handleClose"
	>
		<nut-form class="form">
			<nut-form-item label="标题:" v-if="type !== 'subtitle'">
				<input
					class="nut-input-text"
					placeholder="请输入"
					type="text"
					v-model="form.title"
				/>
			</nut-form-item>
			<template v-if="type === 'view' || type === 'html'">
				<nut-form-item label="时长:">
					<input
						class="nut-input-text"
						placeholder="请输入"
						type="text"
						v-model="form.duration"
						disabled
					/>
					<span>秒</span>
				</nut-form-item>
			</template>
			<template v-if="type === 'subtitle'">
				<nut-input
					class="textarea"
					v-model="form.title"
					type="textarea"
					placeholder="请输入字幕"
					rows="4"
					show-word-limit
					max-length="255"
				/>
				<div class="color-row">
					<nut-form-item label="字体颜色:">
						<div class="color-cell">
							<span
								class="color-tag"
								:style="{
									backgroundColor: form.color,
									color:
										form.color.indexOf('#000') > -1
											? '#fff'
											: '#000',
								}"
								@click="colorQuickSelectVisible = true"
							>
								{{ form.color }}
							</span>
							<span
								class="custom"
								@click="colorCustomSelectVisible = true"
							>
								颜色自定义
							</span>
						</div>
					</nut-form-item>
				</div>
			</template>

			<nut-form-item label="播放顺序:" v-if="type !== 'html'">
				<div class="val" @click="orderPickerShow = true">
					{{ selectedOrderText }}
					<nut-icon
						name="right"
						class-prefix="icon"
						font-class-name="iconfont"
					>
					</nut-icon>
				</div>
			</nut-form-item>
		</nut-form>
	</nut-dialog>

	<nut-picker
		v-model="selectOrder"
		v-model:visible="orderPickerShow"
		:columns="orderColumns"
		title="播放顺序选择"
	>
	</nut-picker>
	<select-color
		v-model:colorQuickSelectVisible="colorQuickSelectVisible"
		v-model:colorCustomSelectVisible="colorCustomSelectVisible"
		v-model:color="form.color"
		:colorOptions="colorOptions"
	/>
</template>

<script>
import { reactive, ref, computed } from 'vue';
import { Toast } from '@nutui/nutui';
import { SelectColor } from '@/components';
import { playlistApi } from '@/apis';
import { createOrderColumns } from '@/constants/pickerColumns';

export default {
	name: 'DetailEditModal',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		type: {
			type: String,
			default: 'view',
		},
		data: {
			type: Object,
			required: true,
		},
		total: {
			type: Number,
			default: 0,
		},
		colorOptions: {
			type: Array,
		},
	},
	components: {
		SelectColor,
	},
	emits: ['update:modelValue', 'success'],
	setup(props, { emit }) {
		const form = reactive({
			title:
				props.type === 'subtitle'
					? props.data.subtitle
					: props.data.title,
			duration: props.data.duration / 1000, // 接口返回duration单位都是ms
			color: props.data.color
				? `${props.data?.color?.indexOf('#') > -1 ? '' : '#'}${
						props.data.color
				  }`
				: '#00C78C',
			popoverVisible: false,
		});
		const colorQuickSelectVisible = ref(false); // 控制快速选择
		const colorCustomSelectVisible = ref(false); // 控制自定义选择
		const orderColumns = createOrderColumns(props.total);
		const orderPickerShow = ref(false);
		const selectOrder = ref([
			props.data.sequence ? props.data.sequence + '' : '0',
		]);
		const selectedOrderText = computed(() => {
			return orderColumns.filter(
				(position) => position.value === selectOrder.value[0]
			)[0]?.text;
		});
		const handleClose = () => {
			emit('update:modelValue', false);
		};
		const handleSave = async () => {
			let api = '';
			const params = {
				id: props.data.id,
				[props.type === 'subtitle' ? 'subtitle' : 'title']: form.title,
				sequence: selectOrder.value[0],
			};
			switch (props.type) {
				case 'view':
					api = playlistApi.playlist_edit_view;
					params.duration = form.duration * 1000;
					break;
				case 'subtitle':
					api = playlistApi.playlist_edit_subtitle;
					params.color = form.color;
					break;
				case 'audio':
					api = playlistApi.playlist_edit_audio;
					break;
				case 'html':
					api = playlistApi.playlist_edit_html;
					params.duration = form.duration * 1000;
			}
			await api(params);
			Toast.success('保存成功～');
			emit('success');
			handleClose();
		};

		return {
			form,
			orderColumns,
			orderPickerShow,
			selectOrder,
			selectedOrderText,
			colorQuickSelectVisible,
			colorCustomSelectVisible,
			handleSave,
			handleClose,
		};
	},
};
</script>

<style lang="scss" scoped>
.form {
	:deep(.nut-cell) {
		padding-left: 0;
		padding-right: 0;
	}
	:deep(.nut-form-item__label) {
		width: auto;
	}

	:deep(.nut-form-item__body__slots) {
		@include flex-center;
		justify-content: flex-end;
	}
	:deep(.nut-input-text) {
		margin-right: 4px;
		text-align: left;
		font-size: 12px;
	}

	.val {
		@include flex-center;
	}

	.color-row {
		:deep(.nut-form-item__body__slots) {
			justify-content: flex-start;
		}
		:deep(.nut-popover--dark) {
			background: none;
		}
		:deep(.vc-chrome) {
			width: 180px;
		}

		.color-cell {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.custom {
			color: #0096ff;
		}
		.color-tag {
			display: inline-block;
			padding: 0 4px;
			height: 20px;
			line-height: 20px;
			color: #fff;
			font-size: $small-font-size;
		}
	}

	.textarea {
		box-sizing: border-box;
		padding: 0;
		border: 1px solid #eaf0fb;
		padding: 6px;
		:deep(textarea) {
			width: 100% !important;
		}
	}
}
</style>
